import submitArrow from '@/assets/svg/dbc-icon-submit-arrow.svg?raw'
import printIcon from '@/assets/svg/dbc-icon-print.svg?raw'
import emailIcon from '@/assets/svg/dbc-icon-email.svg?raw'
import eyeIcon from '@/assets/svg/dbc-icon-eye.svg?raw'
import eyeClosedIcon from '@/assets/svg/dbc-icon-eye-closed.svg?raw'
import passwordIcon from '@/assets/svg/dbc-icon-password.svg?raw'
import chevronDownIcon from '@/assets/svg/dbc-icon-chevron-down.svg?raw'
import navigationLink from '@/assets/svg/dbc-navigation-link.svg?raw'

export default {
  submitArrow,
  printIcon,
  emailIcon,
  eyeIcon,
  eyeClosedIcon,
  passwordIcon,
  chevronDownIcon,
  navigationLink,
}
